import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import CalculatorMm100 from '@/components/calculators/power-kits';
import CalculatorMm100H5 from '@/componentsH5/calculators/power-kits';
import seoconfig from '@/seoconfig/calculators/power-kits';
import SEOlinksA from '@/components/SEOlinksA';

export default function PowerKitPage({ SEO }: any) {
    const { isMobile, useLang } = useGlobal();
    const [isH5, setIsH5] = useState(isMobile);
    const { t } = useLang('shared');
    const router = useRouter();
    const { locale } = router;

    if (typeof window !== 'undefined' && ['sa'].includes(locale as string)) {
        router.push(`${window.location.origin}/${locale}/404`);
    }

    useEffect(() => {
        setIsH5(isMobile);
    }, []);

    return (
        <PageLayout theme={'white'}>
            <SEO title={t('calculators.mm100.seo_title')} description={t('calculators.mm100.seo_desc')} />
            <SEOlinksA locale={router.locale} list={seoconfig.include} pathname={seoconfig.url} />
            {isH5 ? <CalculatorMm100H5 /> : <CalculatorMm100 />}
        </PageLayout>
    );
}
